export { default } from './copy-to-clipboard';